import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';

const ProtectedAdminRoute = ({ children }) => {
  const { admin, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>; // Replace with your loading component
  }

  if (!admin) {
    // Redirect to admin login but save the attempted URL
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  // Check if user has admin privileges
  if (!admin.role || !['admin', 'super_admin'].includes(admin.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;